import { type ImgHTMLAttributes } from 'react'

type ImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'placeholder' | 'loading'> & {
  priority?: boolean
  unoptimized?: boolean
  fill?: boolean
  placeholder?: 'blur' | 'empty'
  blurDataURL?: string
  quality?: number
  loader?: unknown
  sizes?: string
  loading?: 'lazy' | 'eager'
}

export default function Image({
  priority,
  unoptimized: _unoptimized,
  fill,
  placeholder: _placeholder,
  blurDataURL: _blurDataURL,
  quality: _quality,
  loader: _loader,
  loading,
  style,
  ...rest
}: ImageProps) {
  const finalStyle = fill
    ? { position: 'absolute' as const, inset: 0, width: '100%', height: '100%', ...style }
    : style
  return (
    <img
      {...rest}
      style={finalStyle}
      loading={loading ?? (priority ? 'eager' : 'lazy')}
    />
  )
}